<script setup lang="ts">
import Btn from './Btn.vue'
import LoginScreen from './LoginScreen.vue'

defineProps<{
  message?: string
}>()

defineEmits<{
  logout: []
}>()
</script>

<template>
  <LoginScreen hide-login message="" title="You do not have access...">
    <div class="flex flex-1 flex-col justify-between">
      <p class="text-sm leading-[21px] text-neutral-700">
        {{
          message ||
          'Unfortunately, your permissions do not allow access to this app.'
        }}
        Please reach out to
        <a
          class="text-secondary hover:underline"
          href="mailto:support@rialtic.io"
          rel="noopener"
          target="_blank"
        >
          support@rialtic.io
        </a>
        or your company's primary Rialtic contact for further assistance.
      </p>
      <Btn @click="$emit('logout')">Log out</Btn>
      <div />
    </div>
  </LoginScreen>
</template>
